import React from 'react';
import { ProposalView } from '../../../components/Proposals/View';
import type { ProposalViewProps } from '../../../components/Proposals/View';

export const ContractorProposalView: React.FC<ProposalViewProps> = ({ id }) => {
  return <ProposalView id={id} />;
};
